<template>
  <el-container>
    <el-header style="background-color:white;margin-top: 5px;height: 40px;">
      <el-form :inline="true" class="demo-form-inline" size="mini">
        <el-form-item>
          <el-button type="success" icon="el-icon-refresh-right" circle size="mini" @click="getData"></el-button>
        </el-form-item>
      </el-form>
    </el-header>
    <el-main class="elMain">
      <el-table v-loading="loading" :data="data" height="100%" stripe border size="medium ">
        <el-table-column align="center" label="ID" prop="id"></el-table-column>
        <el-table-column align="center" label="最后修改人" prop="admin_name"></el-table-column>
        <el-table-column align="center" label="当前状态" prop="confirm">
          <template slot-scope="scope">
            <span style="color: green;" v-if="scope.row.confirm=='1'">允许下单</span>
            <span style="color: red;" v-else>不允许下单</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="修改时间" prop="time">
          <template slot-scope="scope">
            <span>{{scope.row.time*1 | formatDate}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="300">
          <template slot-scope="scope">
            <span>
              <el-popconfirm
                confirmButtonText='好的'
                cancelButtonText='不用了'
                icon="el-icon-info"
                iconColor="red"
                title="确定需要修改么？"
                @onConfirm="deletes(scope.$index, scope.row)"
              >
                <el-button size="small" slot="reference">修改</el-button>
              </el-popconfirm>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>

</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
export default {
  data () {
    return {
      loading:false,
      data:'',
      //管理员相关信息
      AdminInfor:{
        id:'',
        name:'',
        photo:'',
        type:'',
      },
    }
  },
  //页面开启时执行
  //页面开启时执行
  mounted(){
    this.chark();
    this.getData();
  },
  methods: {
    //删除
    deletes(index, row) {
      let admin_id=this.$store.state.a_id;
      row.admin_id=admin_id;
      //console.log(index, row);
      if(row.confirm=='1'){
        row.confirm='0';
      }else{
        row.confirm='1';
      }
      commonAPI('updateConfirm',row).then(res => {
        let data = res.data;
        //console.log(res.data.rows);
        if(this.response.response(data)){
          this.getData();
        }
      }).catch(error=>{
          this.loading = false;
          this.$notify({//这里采用element ui的一个错误显示效果模板
            title: '提示',
            message: error.message,
            position: 'bottom-right',
            type: 'error'
          });
          })
    },
    //进行判定
    chark(){
      this.$emit("parentHandle", 2)
    },
    getData() {
      this.loading = true,
        commonAPI('queryAConfirm',this.AdminInfor).then(res => {
          this.loading = false;
          this.data = res.data.data.rows;
          //console.log(res.data.rows);
        })
    },
    //获取信息方法
    judgeLogin(){
      this.AdminInfor.id=this.$store.state.a_id;
    },
  }
}
</script>

<style scoped>
  .elInput,
  .btn {
    margin-top: 0px;
  }
  .el-main {
    padding: 0px 10px;
  }
  .elMain{
    height: 700px;
  }
  .el-table th {
    height: 45px;
    font-size: 16px;
    font-family: 微软雅黑;
    font-weight: 500;
    color: darkblue;
  }
</style>



// WEBPACK FOOTER //
// src/admin/views/system/OrderConfirm.vue